import {Styles} from 'appearance'
import {MEDIA_TYPES} from 'constants/dance'
import {getRequestTitle} from 'services/utils'
import {
    useI18n,
    useDeleteMediaMutation,
    useUpdateMediaMutation,
} from 'store/Store'

const useMediaActions = (media) => {
    const {i18n} = useI18n()
    const [deleteMedia] = useDeleteMediaMutation()
    const [updateMedia] = useUpdateMediaMutation()

    const {mediaType} = media || {}

    const handleAction = (action, args) => action(args)

    const t = (label, input) => i18n.t(`user.requests.${label}`, input)

    const isSong = mediaType === MEDIA_TYPES.song
    const confirmText = t('pending')
    const requestTitle = getRequestTitle(mediaType, t)
    const buttonSX = Styles.ACTION_BUTTON

    return {
        requestTitle,
        confirmText,
        confirmRequest: () =>
            handleAction(updateMedia, {
                mediaId: media._id,
                body: {isConfirmed: true},
            }),
        refuseRequest: () => handleAction(deleteMedia, {mediaId: media._id}),
        isSong,
        buttonSX,
    }
}

export default useMediaActions
